import { Routes, RouterModule, ExtraOptions, PreloadAllModules } from '@angular/router';
import { NgModule } from '@angular/core';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/inicio',
    pathMatch: 'full',
  },
  {
    path: '',
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./views/public/public.module').then((m) => m.PublicModule),
      },
    ]
  },
  {
    path: 'admin',
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./views/admin/admin.module').then((m) => m.AdminModule),
      },
    ]
  },
  {
    path: '**',
    loadChildren: () =>
      import('./components/shared/error404/error404.module').then(
        (m) => m.Error404Module
      ),
  },
];

// export const AppRoutes = RouterModule.forRoot(APP_ROUTES);

//Estratégia para carregamento dos componentes (preloadingStrategy: PreloadAllModules || AuthPreloadStrategy = lazy loading)
// const routerConfig: ExtraOptions = {
//   scrollPositionRestoration: 'enabled',
//   preloadingStrategy: PreloadAllModules,
//   relativeLinkResolution: 'legacy',
//   useHash: true,
// };

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }